import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import actions from '../actions';
import BoardActions from '../components/BoardActions';

const mapStateToProps = (state) => {
  const currentUser = selectors.selectCurrentUser(state);
  const currentBoard = selectors.selectCurrentBoard(state);
  const currentBoardId = currentBoard ? currentBoard.id : null;
  const currentBoardName = currentBoard ? currentBoard.name : null;
  const filterText = selectors.selectFilterTextForCurrentBoard(state);
  const boardLabels = selectors.selectLabelsForCurrentBoard(state);
  const filterLabels = selectors.selectFilterLabelsForCurrentBoard(state);
  const filterUsers = selectors.selectFilterUsersForCurrentBoard(state);
  const includeCardsWithoutMembers =
    selectors.selectIncludeCardsWithoutMembersForCurrentBoard(state);
  const includeCardsWithoutLabels = selectors.selectIncludeCardsWithoutLabelsForCurrentBoard(state);
  const boardMemberships = selectors.selectMembershipsForCurrentBoard(state);
  console.log('Voila le boardmemberships');
  console.log(boardMemberships);
  const searchedUsers = selectors.selectSearchedUsers(state);
  console.log('Voila le searched users');
  console.log(searchedUsers);
  const isSearchingUsers = selectors.selectIsSearchingUsers(state);
  const cards = selectors.selectCardsWithDetailsForCurrentBoard(state);
  const lists = selectors.selectListsForCurrentBoard(state);
  const listIds = selectors.selectListIdsForCurrentBoard(state); // ─── #1 ───

  const isCurrentUserManager = selectors.selectCanManageCurrentProject(state);

  const isCurrentUserMember = selectors.selectCanViewBoard(state);
  const isCurrentUserEditor = selectors.selectCanEditBoard(state);

  return {
    currentUser,
    currentBoardId,
    currentBoardName,
    filterText,
    filterUsers,
    includeCardsWithoutMembers,
    boardLabels,
    filterLabels,
    includeCardsWithoutLabels,
    boardMemberships,
    canEdit: isCurrentUserEditor || isCurrentUserManager,
    canEditMemberships: isCurrentUserEditor || isCurrentUserManager,
    canSeeMemberships: isCurrentUserMember || isCurrentUserManager,
    isBoardPublic: currentBoard ? currentBoard.isPublic : false,
    searchedUsers,
    isSearchingUsers,
    cards,
    lists,
    firstListId: listIds && listIds.length > 0 ? listIds[0] : null, // ─── #1 ───
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onTextFilterUpdate: entryActions.filterText,
      onUserToFilterAdd: entryActions.addUserToFilterInCurrentBoard,
      onUserFromFilterRemove: entryActions.removeUserFromFilterInCurrentBoard,
      onLabelToFilterAdd: entryActions.addLabelToFilterInCurrentBoard,
      onLabelFromFilterRemove: entryActions.removeLabelFromFilterInCurrentBoard,
      onLabelCreate: entryActions.createLabelInCurrentBoard,
      onLabelUpdate: entryActions.updateLabel,
      onLabelMove: entryActions.moveLabel,
      onLabelDelete: entryActions.deleteLabel,
      onMembershipCreate: entryActions.createUserRoleAssignmentInCurrentBoard,
      onMembershipUpdate: entryActions.updateUserRoleAssignment,
      onMembershipDelete: entryActions.deleteUserRoleAssignment,
      onBoardUpdate: entryActions.updateBoard,
      onSearchUsers: actions.searchUsers,
      onClearUserSearch: actions.clearUserSearch,
      onCardCreate: entryActions.createCard, // ─── #1 : (listId, data, autoOpen) ───
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(BoardActions);
